import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/api";
import { InquiryModal } from "./InquiryModal";

export const SoldGallery = () => {
  const [sold, setSold] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api
      .get("/products?status=sold")
      .then((r) => setSold(r.data))
      .catch(() => {});
  }, []);

  if (!sold.length) return null;

  return (
    <section data-testid="sold-gallery" className="border-t-2 border-[#F5F2EB] px-6 py-24 md:px-12 md:py-28 lg:px-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12 flex flex-wrap items-end justify-between gap-6"
      >
        <div>
          <p className="mb-4 inline-block rounded-full border-2 border-[#F5F2EB] bg-[#141414] px-4 py-1 text-[10px] font-mono font-medium uppercase tracking-[0.25em]">
            03 — Gone but not forgotten
          </p>
          <h2 data-testid="sold-gallery-heading" className="font-serif font-black uppercase leading-none tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Already re-homed
          </h2>
        </div>
        <p className="max-w-xs text-xs font-mono uppercase leading-relaxed tracking-[0.15em] text-[#F5F2EB]/60">
          These pieces found their second owner. Yours could be next — nothing here ever comes back.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
        {sold.map((p, i) => (
          <motion.button
            key={p.id}
            type="button"
            data-testid={`sold-card-${p.id}`}
            onClick={() => setActive(p)}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
            className="group overflow-hidden rounded-xl border-2 border-[#F5F2EB] bg-[#141414] text-left transition-all duration-200 hover:-translate-y-1 hover:shadow-[5px_5px_0_#F5F2EB]"
          >
            <div className="relative aspect-square overflow-hidden border-b-2 border-[#F5F2EB]">
              <img
                src={p.image}
                alt={p.title}
                loading="lazy"
                className="h-full w-full object-cover opacity-70 grayscale transition-all duration-500 group-hover:opacity-90"
              />
              <span className="absolute right-3 top-3 -rotate-6 rounded-md border-2 border-[#F5F2EB] bg-[#FF3B1F] px-3 py-1 font-serif text-xs font-black uppercase tracking-wide text-white shadow-[3px_3px_0_#F5F2EB]">
                Gone
              </span>
            </div>
            <div className="p-3">
              <p className="font-serif text-sm font-extrabold uppercase leading-tight">{p.title}</p>
              <p className="mt-1 text-[10px] font-mono uppercase tracking-[0.15em] text-[#F5F2EB]/50">Sold for ${p.price}</p>
            </div>
          </motion.button>
        ))}
      </div>

      <InquiryModal product={active} onClose={() => setActive(null)} />
    </section>
  );
};
